// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnails-wrapper-form {
  margin: 12px 0;
  display: inline-block;
  width: 100%;
  animation-name: bubbleAnim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.thumbnails-wrapper-form.forms-thumbnails {
  margin-top: 30px;
  padding: 0 16px;
}
.thumbnails-wrapper-form .thumbnail-data-content {
  background: var(--sdk-global-white-bg);
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 4px;
  padding: 15px;
  max-width: 75%;
  height: 200px;
  transition: 0.3s all ease;
  cursor: pointer;
}
.thumbnails-wrapper-form .thumbnail-data-content:hover {
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  transform: scale(1.03);
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/inlineForm/inlineForm.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,qBAAA;EACA,WAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AACJ;AAAI;EACI,gBAAA;EACA,eAAA;AAER;AAAI;EACI,sCAAA;EACA,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AAER;AADQ;EACI,mDAAA;EACA,sBAAA;AAGZ","sourcesContent":[".thumbnails-wrapper-form{\n    margin: 12px 0;\n    display: inline-block;\n    width: 100%;\n    animation-name: bubbleAnim;\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    opacity: 0;\n    &.forms-thumbnails{\n        margin-top: 30px;\n        padding: 0 16px;\n    }\n    .thumbnail-data-content{\n        background: var(--sdk-global-white-bg);\n        border: 1px solid var(--sdk-gloabl-border-color);\n        border-radius: 4px;\n        padding: 15px;\n        max-width: 75%;\n        height: 200px;\n        transition: 0.3s all ease;\n        cursor: pointer;\n        &:hover{\n            box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n            transform: scale(1.03);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
